import type { IPayoutRepository, PayoutListOptions } from '../repositories/IPayoutRepository.js';

export type UploadPayoutReceiptInput = Parameters<IPayoutRepository['uploadReceipt']>[0];

interface Deps { payoutRepository: IPayoutRepository; }

export function createListPayoutsUseCase({ payoutRepository }: Deps) {
  return (options: PayoutListOptions) => payoutRepository.list(options);
}

export function createListAllPayoutsUseCase({ payoutRepository }: Deps) {
  return (options: PayoutListOptions) => payoutRepository.listRaw(options);
}

export function createGetPayoutBySessionUseCase({ payoutRepository }: Deps) {
  return (sessionId: string) => payoutRepository.getBySessionId(sessionId);
}

export function createSubmitPayoutEventUseCase({ payoutRepository }: Deps) {
  return (input: Parameters<IPayoutRepository['submitEvent']>[0]) => payoutRepository.submitEvent(input);
}

export function createClosePayoutRequestUseCase({ payoutRepository }: Deps) {
  return (input: { sessionId: string; reason: string }) =>
    payoutRepository.closeRequest(input.sessionId, input.reason);
}

export function createCreatePayoutRequestUseCase({ payoutRepository }: Deps) {
  return (input: { sessionId: string; formxSubmissionId: string }) =>
    payoutRepository.createRequest(input.sessionId, input.formxSubmissionId);
}

export function createUploadPayoutReceiptUseCase({ payoutRepository }: Deps) {
  return (input: Parameters<IPayoutRepository['uploadReceipt']>[0]) =>
    payoutRepository.uploadReceipt(input);
}

export function createReceiptUploadTargetUseCase({ payoutRepository }: Deps) {
  return (input: Parameters<IPayoutRepository['createReceiptUploadTarget']>[0]) =>
    payoutRepository.createReceiptUploadTarget(input);
}

export function createUploadReceiptToSignedUrlUseCase({ payoutRepository }: Deps) {
  return (input: Parameters<IPayoutRepository['uploadReceiptToSignedUrl']>[0]) =>
    payoutRepository.uploadReceiptToSignedUrl(input);
}

export function createGetReceiptUrlIfUploadedUseCase({ payoutRepository }: Deps) {
  return (bucket: string, path: string) => payoutRepository.getReceiptUrlIfUploaded(bucket, path);
}

export function createInvokeVerifyPayoutUseCase({ payoutRepository }: Deps) {
  return (payoutId: string) => payoutRepository.invokeVerify(payoutId);
}

export function createCanCloseSessionUseCase({ payoutRepository }: Deps) {
  return (sessionId: string) => payoutRepository.canCloseSession(sessionId);
}

export function createAdminCreatePayoutUseCase({ payoutRepository }: Deps) {
  return (input: { orgId: string; projectId: string; locationId: string }) =>
    payoutRepository.adminCreate(input);
}

export function createAdminDeletePayoutUseCase({ payoutRepository }: Deps) {
  return (sessionId: string) => payoutRepository.adminDeleteBySession(sessionId);
}
